export default "__VITE_ASSET__BuYKEhoD__"